{
  "NLAMS" : [
    {
      "code" : "M32",
      "name" : "Amsterdam Rijnkanaal",
      "atSea" : false
    },
    {
      "code" : "M36",
      "name" : "Oranjesluizen",
      "atSea" : false
    },
    {
      "code" : "NHK",
      "name" : "Noordhollandskanaal",
      "atSea" : false
    },
    {
      "code" : "OSD",
      "name" : "Oosterdok",
      "atSea" : false
    },
    {
      "code" : "SEA",
      "name" : "Zee",
      "atSea" : true
    },
    {
      "code" : "ZKC",
      "name" : "Zijkanaal C",
      "atSea" : false
    },
    {
      "code" : "ZKD",
      "name" : "Zijkanaal D",
      "atSea" : false
    },
    {
      "code" : "ZN",
      "name" : "Zaan",
      "atSea" : false
    }
  ],
  "NLANK" : [
    {
      "code" : "BEANR",
      "name" : "ANTWERPEN",
      "atSea" : true
    },
    {
      "code" : "BEGNE",
      "name" : "GENT",
      "atSea" : false
    },
    {
      "code" : "BEOST",
      "name" : "OOSTENDE",
      "atSea" : true
    },
    {
      "code" : "BESEA0WEST00AWN",
      "name" : "WANDELAAR",
      "atSea" : true
    },
    {
      "code" : "BEZEE",
      "name" : "ZEEBRUGGE",
      "atSea" : true
    },
    {
      "code" : "NLBRS",
      "name" : "BRESKENS",
      "atSea" : true
    },
    {
      "code" : "NLHAN",
      "name" : "HANSWEERT",
      "atSea" : false
    },
    {
      "code" : "NLTNZ",
      "name" : "TERNEUZEN",
      "atSea" : false
    },
    {
      "code" : "NLWKP0131J000SB",
      "name" : "STEENBANK",
      "atSea" : true
    },
    {
      "code" : "NLWSO",
      "name" : "WALSOORDEN",
      "atSea" : false
    }
  ],
  "NLBRS" : [
    {
      "code" : "G4",
      "name" : "Oostgat",
      "atSea" : false
    },
    {
      "code" : "O8",
      "name" : "Overig",
      "atSea" : true
    },
    {
      "code" : "S1",
      "name" : "Schelde",
      "atSea" : false
    }
  ],
  "NLBZM" : [
    {
      "code" : "BZMBD",
      "name" : "Bergsche Diep",
      "atSea" : true
    }
  ],
  "NLDHR" : [
    {
      "code" : "KV",
      "name" : "Koopvaardersschutsluis",
      "atSea" : false
    },
    {
      "code" : "NK",
      "name" : "Noordhollandskanaal",
      "atSea" : false
    },
    {
      "code" : "SA",
      "name" : "SEA",
      "atSea" : true
    },
    {
      "code" : "VVG",
      "name" : "Verversgat",
      "atSea" : true
    }
  ],
  "NLDZL" : [
    {
      "code" : "DZL-E",
      "name" : "Delfzijl Breakwaters",
      "atSea" : true
    },
    {
      "code" : "DZL-K",
      "name" : "Delfzijl Eemskanaal",
      "atSea" : false
    },
    {
      "code" : "EEM-D",
      "name" : "Eemshaven Breakwaters",
      "atSea" : true
    }
  ],
  "NLFOX" : [
    {
      "code" : "SEA",
      "name" : "Zee",
      "atSea" : true
    }
  ],
  "NLGRQ" : [
    {
      "code" : "SEA",
      "name" : "Zee",
      "atSea" : true
    }
  ],
  "NLHAN" : [
    {
      "code" : "G2",
      "name" : "Oostgat",
      "atSea" : false
    },
    {
      "code" : "O5",
      "name" : "Overig",
      "atSea" : true
    },
    {
      "code" : "O9",
      "name" : "Overige",
      "atSea" : true
    },
    {
      "code" : "S2",
      "name" : "Schelde",
      "atSea" : false
    }
  ],
  "NLHAR" : [
    {
      "code" : "BO",
      "name" : "Boontjes",
      "atSea" : true
    },
    {
      "code" : "BS",
      "name" : "Blauwe Slenk",
      "atSea" : true
    },
    {
      "code" : "HK",
      "name" : "Van Harinxma Kanaal",
      "atSea" : false
    }
  ],
  "NLITR" : [
    {
      "code" : "ITRJN",
      "name" : "Julianakanaal Noord",
      "atSea" : true
    },
    {
      "code" : "ITRJZ",
      "name" : "Julianakanaal Zuid",
      "atSea" : false
    }
  ],
  "NLKAM" : [
    {
      "code" : "KAMIJ",
      "name" : "IJssel",
      "atSea" : false
    },
    {
      "code" : "KAMKET",
      "name" : "Keteldiep",
      "atSea" : true
    }
  ],
  "NLLAN" : [
    {
      "code" : "LW",
      "name" : "Waddenzee",
      "atSea" : true
    },
    {
      "code" : "S5",
      "name" : "Sea",
      "atSea" : true
    }
  ],
  "NLLWR" : [
    {
      "code" : "LWRHAR",
      "name" : "Van Harinxmakanaal",
      "atSea" : false
    }
  ],
  "NLMID" : [
    {
      "code" : "BESEA0WEST00AWN",
      "name" : "WANDELAAR",
      "atSea" : true
    },
    {
      "code" : "NLWKP0131J000SB",
      "name" : "STEENBANK",
      "atSea" : true
    }
  ],
  "NLMSB" : [
    {
      "code" : "MSBJ",
      "name" : "Julianakanaal",
      "atSea" : false
    },
    {
      "code" : "MSBM",
      "name" : "Maas",
      "atSea" : true
    }
  ],
  "NLOMD" : [
    {
      "code" : "OMDMN",
      "name" : "Maas Noord",
      "atSea" : true
    },
    {
      "code" : "OMDMZ",
      "name" : "Maas Zuid",
      "atSea" : false
    }
  ],
  "NLRTM" : [
    {
      "code" : "LL",
      "name" : "Lage Licht",
      "atSea" : true
    },
    {
      "code" : "MB",
      "name" : "Maasbruggen",
      "atSea" : false
    },
    {
      "code" : "OM",
      "name" : "Oude Maas",
      "atSea" : false
    },
    {
      "code" : "OV",
      "name" : "OVERIG",
      "atSea" : true
    }
  ],
  "NLSCE" : [
    {
      "code" : "SCHNZ",
      "name" : "Zee",
      "atSea" : true
    }
  ],
  "NLSMD" : [
    {
      "code" : "SEA",
      "name" : "Zee",
      "atSea" : true
    }
  ],
  "NLTEX" : [
    {
      "code" : "SEA",
      "name" : "Zee",
      "atSea" : true
    }
  ],
  "NLTNZ" : [
    {
      "code" : "BEANR",
      "name" : "ANTWERPEN",
      "atSea" : false
    },
    {
      "code" : "BEGNE",
      "name" : "GENT",
      "atSea" : false
    },
    {
      "code" : "BEOST",
      "name" : "OOSTENDE",
      "atSea" : false
    },
    {
      "code" : "BESEA0WEST00AWN",
      "name" : "WANDELAAR",
      "atSea" : true,
      "pilotStation" : true
    },
    {
      "code" : "BEZEE",
      "name" : "ZEEBRUGGE",
      "atSea" : false
    },
    {
      "code" : "NLBRS",
      "name" : "BRESKENS",
      "atSea" : false
    },
    {
      "code" : "NLHAN",
      "name" : "HANSWEERT",
      "atSea" : false
    },
    {
      "code" : "NLVLI",
      "name" : "VLISSINGEN",
      "atSea" : false
    },
    {
      "code" : "NLWKP0131J000SB",
      "name" : "STEENBANK",
      "atSea" : true,
      "pilotStation" : true
    },
    {
      "code" : "NLWSO",
      "name" : "WALSOORDEN",
      "atSea" : false
    }
  ],
  "NLURK" : [
    {
      "code" : "URKIJS",
      "name" : "IJsselmeer",
      "atSea" : true
    }
  ],
  "NLVDM" : [
    {
      "code" : "SEA",
      "name" : "Zee",
      "atSea" : true
    }
  ],
  "NLVEN" : [
    {
      "code" : "VENMN",
      "name" : "Maas Noord",
      "atSea" : true
    },
    {
      "code" : "VENMZ",
      "name" : "Maas Zuid",
      "atSea" : false
    }
  ],
  "NLVLI" : [
    {
      "code" : "BEANR",
      "name" : "ANTWERPEN",
      "atSea" : false
    },
    {
      "code" : "BEGNE",
      "name" : "GENT",
      "atSea" : false
    },
    {
      "code" : "BEOST",
      "name" : "OOSTENDE",
      "atSea" : false
    },
    {
      "code" : "BESEA0WEST00AWN",
      "name" : "WANDELAAR",
      "atSea" : true,
      "pilotStation" : true
    },
    {
      "code" : "BEZEE",
      "name" : "ZEEBRUGGE",
      "atSea" : false
    },
    {
      "code" : "NLBRS",
      "name" : "BRESKENS",
      "atSea" : false
    },
    {
      "code" : "NLHAN",
      "name" : "HANSWEERT",
      "atSea" : false
    },
    {
      "code" : "NLTNZ",
      "name" : "TERNEUZEN",
      "atSea" : false
    },
    {
      "code" : "NLVLI",
      "name" : "VLISSINGEN",
      "atSea" : false
    },
    {
      "code" : "NLWKP0131J000SB",
      "name" : "STEENBANK",
      "atSea" : true,
      "pilotStation" : true
    },
    {
      "code" : "NLWSO",
      "name" : "WALSOORDEN",
      "atSea" : false
    }
  ],
  "NLWHZ" : [
    {
      "code" : "SEA",
      "name" : "Zee",
      "atSea" : true
    }
  ],
  "NLWKD" : [
    {
      "code" : "WKDMWD1",
      "name" : "Beneden Merwede",
      "atSea" : true
    },
    {
      "code" : "WKDMWD2",
      "name" : "Nieuwe Merwede",
      "atSea" : true
    },
    {
      "code" : "WKDMWD3",
      "name" : "Boven Merwede",
      "atSea" : false
    }
  ],
  "NLWRG" : [
    {
      "code" : "SEA",
      "name" : "Zee",
      "atSea" : true
    }
  ],
  "NLWTE" : [
    {
      "code" : "SEH",
      "name" : "SEA",
      "atSea" : true
    }
  ]
}
